import React from 'react'
import PropTypes from 'prop-types'
import {
  FacebookShareButton,
  FacebookIcon,
  RedditShareButton,
  RedditIcon,
  TwitterShareButton,
  TwitterIcon,
  LinkedinShareButton,
  LinkedinIcon,
  EmailShareButton,
  EmailIcon,
} from 'react-share'

const SocialShare = ({ url, title, twitterHandle }) => (
  <div className="blog-post-sharebutton-container">
    <FacebookShareButton
      url={url}
      quote={title}
      className="blog-post-sharebutton-item"
    >
      <FacebookIcon size={32} round />
    </FacebookShareButton>
    <TwitterShareButton
      url={url}
      title={title}
      className="blog-post-sharebutton-item"
      via={twitterHandle.split('@').join('')}
    >
      <TwitterIcon size={32} round />
    </TwitterShareButton>
    <RedditShareButton
      url={url}
      title={title}
      windowWidth={660}
      windowHeight={460}
      className="blog-post-sharebutton-item"
    >
      <RedditIcon size={32} round />
    </RedditShareButton>
    <LinkedinShareButton url={url} className="blog-post-sharebutton-item">
      <LinkedinIcon size={32} round />
    </LinkedinShareButton>
    <EmailShareButton
      url={url}
      subject={title}
      className="blog-post-sharebutton-item"
    >
      <EmailIcon size={32} round />
    </EmailShareButton>
  </div>
)

SocialShare.propTypes = {
  url: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  twitterHandle: PropTypes.string.isRequired,
}

export default SocialShare
